import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quote-open",
  "use": "icon-quote-open-usage",
  "viewBox": "0 0 33 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 25\" id=\"icon-quote-open\"><path d=\"M12.07,0l.8,1.64A32.27,32.27,0,0,0,8.14,5.53q-3.2,3.29-3.2,6,0,1.64,1.45,1.64H8a5.3,5.3,0,0,1,3.42,1.1,5.63,5.63,0,0,1,2,4.71,5.87,5.87,0,0,1-1.67,4.42A5.91,5.91,0,0,1,7.41,25a6.4,6.4,0,0,1-5.56-2.57A9.89,9.89,0,0,1,0,16.49,15.49,15.49,0,0,1,4.58,5.6,33.72,33.72,0,0,1,12.07,0ZM31.69,0l.8,1.64a32.27,32.27,0,0,0-4.72,3.88q-3.2,3.29-3.2,6,0,1.64,1.45,1.64h1.6A5.3,5.3,0,0,1,31,14.25,5.63,5.63,0,0,1,33,19a5.66,5.66,0,0,1-6,6,6.4,6.4,0,0,1-5.56-2.57,9.89,9.89,0,0,1-1.85-5.93A15.49,15.49,0,0,1,24.2,5.6,33.72,33.72,0,0,1,31.69,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/quote-open.svg
// module id = 164
// module chunks = 0 1 2